/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import React, { createContext, PropsWithChildren, useContext, useMemo, useState } from 'react';
import { ProfileObject } from '../types/Profile';

type ProfileContextType = {
  data: ProfileObject;
  onDataUpdate: Function;
  clear: Function;
  load: Function;
};

const ProfileContext = createContext<ProfileContextType>({
  data: JSON.parse(localStorage.getItem('profileContext') || '{}'),
  onDataUpdate: () => { },
  clear: () => { },
  load: () => { },
});

export function ProfileContextProvider(props: PropsWithChildren) {
  const { children } = props;
  const [data, setData] = useState<Object>(JSON.parse(localStorage.getItem('profileContext') || '{}'));

  const onDataUpdate = (value: Object) => {
    setData((prevData) => {
      const newData = { ...prevData, ...value };
      localStorage.setItem('profileContext', JSON.stringify(newData));
      return newData;
    });
  };

  const clear = () => {
    setData(() => ({}));
    localStorage.removeItem('profileContext');
  };

  const load = () => {
    const sotredData = JSON.parse(localStorage.getItem('profileContext') || '{}');
    setData(() => sotredData);
  };

  const profileContextValue = useMemo(() => ({ data, onDataUpdate, clear, load }), [data]);
  return <ProfileContext.Provider value={profileContextValue}> {children} </ProfileContext.Provider>;
}

const useProfile = () => useContext(ProfileContext);
export default useProfile;